module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hideHead) ? _c('div', {
    staticClass: "rt-header rt-crm-header plat-crm-header"
  }, [_c('h2', {
    staticClass: "plat-crm-header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f535194"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/header/src/main.vue
// module id = 2135
// module chunks = 228